const home = {
  path: 'home',
  component: resolve => require(['../../../pages/home'], resolve),
  meta: {
    requireAuth: true
  }
}

export default home
